export default __webpack_public_path__ + "static/like_collect_background-7e175dc6cceb445f6032ebc938e1ca89.png";